/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql } from '@apollo/client';
import { handleApolloError } from '@exo/frontend-common-apollo';
import { useSessionContext } from '@exo/frontend-common-session-context';

export const usePriceRange = (partNumber, ccyCode, fetchPolicy,skipCondition?) => {
  const session = useSessionContext();
  const variables = {
    partNumber,
    ccyCode
  };

  const PRICE_GQL = gql`
    query Price($partNumber: [String!]!, $ccyCode: String!) {
      price(partNumber: $partNumber, ccy_code: $ccyCode) {
        resourceName
        id
        entitledPrice {
          id
          productId
          contractId
          partNumber
          unitPrice {
            price {
              currency
              value
            }
            quantity {
              uom
              value
            }
          }
          rangePrice {
            currency
            maximumQuantity {
              uom
              value
            }
            minimumQuantity {
              uom
              value
            }
            priceInRange {
              currency
              value
            }
          }
        }
      }
    }
  `;
  const currentTime = Date.now();
  const timeRemaining = session?.targetTimer ? (session.targetTimer - currentTime) / (1000 * 60) : 0;
  const { loading, error, data, refetch } = useQuery(PRICE_GQL, {
    variables,
    fetchPolicy: fetchPolicy,
    skip: skipCondition,
    context:{clientName:"/price"}
  });

  handleApolloError(__filename, error);

  return { error, loading, data, refetch };
};

export const useOnSaleBuyPriceRange = (partNumber, ccyCode, fetchPolicy,skipCondition?) => {
  const session = useSessionContext();
  const variables = {
    partNumber,
    ccyCode
  };

  const ONSALE_PRICE_GQL = gql`
    query GetOnSaleBuyPrice($partNumber: [String!]!, $ccyCode: String!) {
      getOnSaleBuyPrice(partNumber: $partNumber, ccy_code: $ccyCode) {
        resourceName
        resultList {
          catalogEntryId
          partNumber
          priceRuleName
          unitPrice {
            price {
              currency
              value
            }
            quantity {
              uom
              value
            }
          }
          priceRuleId
        }
      }
    }
  `;
  const currentTime = Date.now();
  const timeRemaining = session?.targetTimer ? (session.targetTimer - currentTime) / (1000 * 60) : 0;
  const { loading, error, data, refetch } = useQuery(ONSALE_PRICE_GQL, {
    variables,
    fetchPolicy: fetchPolicy,
    skip: skipCondition,
    context:{
      clientName:"/price"
    }
  });

  handleApolloError(__filename, error);

  return { error, loading, data, refetch };
};
